import React, { useEffect, useState, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import './chat.css';
import { sendMessage, startChat, sendCSATFeedback, sendFile, checkLatestConversation, resumeConversation, initializeFeatureFlagsCache, getApiBaseUrl } from '../../functions/apiCalls/api';
import { startWebhookSSEListener, latestInputControls } from '../../functions/webhook/webhookService';
import { useWebhookMessageAcceptance } from './useWebhookMessageAcceptance';
import { buttonRequestContext } from './buttonRequestContext';
import ChatMessage from '../messageComponent/message';
import CSATComponent from '../csatComponent/csat';
import { v4 as uuidv4 } from 'uuid';
import sanitizeInput, { isValidInput } from '../../utils/security';
import { getLatestButtonLink } from '../../utils/buttonLink';
import { IoClose } from 'react-icons/io5';


const getWebhookConversationId = () => typeof window !== 'undefined' ? window.currentConversationId : null;

export default function ChatComponent({ chatActive, setChatActive, chatHeader, setMessages, setClient_id, client_id, messages }) {
    const acceptWebhookMessage = useWebhookMessageAcceptance({ messages, setMessages, getConversationId: getWebhookConversationId });
    const [inputValue, setInputValue] = useState('');
    const [searchParams] = useSearchParams();

    const isSdkParam = searchParams.get('sdk');
    const disableHistoryParam = searchParams.get('disable_history') || searchParams.get('disableHistory');
    const isSdk = isSdkParam === 'true' || 
                  isSdkParam === '1' || 
                  disableHistoryParam === 'true' || 
                  disableHistoryParam === '1' ||
                  (typeof window !== 'undefined' && (window.isSdk || window.fleuryChatConfig?.isSdk));
    const [uuid, setUuid] = useState(uuidv4());
    const [teste2, setTeste2] = useState(false);
    const [location, setLocation] = useState({ lat: null, long: null })
    const [teste3, setTeste3] = useState(false);
    const [contadorGeoLoc, setContadorGeoLoc] = useState(false);
    const [isInputDisabled, setIsInputDisabled] = useState(false);
    const [bloqueiaInputLetras, setBloqueiaInputLetras] = useState(false);
    const [newIdd, setNewId] = useState('');
    const [trustedButtonMessages, setTrustedButtonMessages] = useState([]);
    const [chatResetKey, setChatResetKey] = useState(0);
    const [charCount, setCharCount] = useState(0);
    const isAreaLogada = searchParams.get('origem') === 'area_logada';
    const NORMAL_CHAR_LIMIT = isAreaLogada ? 1200 : 280;
    const FEEDBACK_CHAR_LIMIT = 320;
    const ELOGIO_CHAR_LIMIT = 280;
    const [showInputFeedback, setShowInputFeedback] = useState(false);
    const [currentCharLimit, setCurrentCharLimit] = useState(NORMAL_CHAR_LIMIT);
    const [limitMessageShown, setLimitMessageShown] = useState(false);
    const [requestId, setRequestId] = useState('');
    // Estados para o CSAT
    const [showCSAT, setShowCSAT] = useState(false);
    const [csatTimeout, setCsatTimeout] = useState(null);
    const csatTimeoutRef = useRef(null);
    const csatPendingAfterPaymentRef = useRef(false);
    const startCSATTimerRef = useRef(null);
    // Estado para controlar quantas vezes o OCR de exames foi acionado
    const [ocrExamesCount, setOcrExamesCount] = useState(0);

    // Estados para o timer de confirmação de agendamento
    const [timerSeconds, setTimerSeconds] = useState(null);
    const [timerActive, setTimerActive] = useState(false);
    const [showWarningModal, setShowWarningModal] = useState(false);
    const [showExpiredModal, setShowExpiredModal] = useState(false);
    const [isBookingTimeExpired, setIsBookingTimeExpired] = useState(false);
    // Ref que guarda o timestamp absoluto (ms) de quando o timer deve expirar.
    // Usado para corrigir a contagem quando o app vai para segundo plano
    // (browsers throttlem setInterval nesses casos).
    const timerEndTimeRef = useRef(null);
    const warningFiredRef = useRef(false);

    const messagesEndRef = useRef(null);
    const textareaRef = useRef(null);

    const client_recebido = client_id;

    const inputOpen = process.env.REACT_APP_CHAT_OPEN_INPUT || 'true';
    const timeout = process.env.REACT_APP_CHAT_TIMEOUT_GEOLOC;
    const csatDisplayTimeout = process.env.REACT_APP_CSAT_TIMEOUT ? parseInt(process.env.REACT_APP_CSAT_TIMEOUT) : 2000;
    const ocrPollingIntervalMs = Number.parseInt(process.env.REACT_APP_OCR_POLLING_INTERVAL_MS || '', 10) || 5000;
    const ocrMaxAttempts = Number.parseInt(process.env.REACT_APP_OCR_MAX_ATTEMPTS || '', 10) || 40;
    const apiBaseUrl = getApiBaseUrl();

    const sistema = searchParams.get('operational_system');
    const versao = searchParams.get('version_app');

    const scrollToBottom = () => {
        if (messages.length > 1) {
            messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    useEffect(() => {
        scrollToBottom();

        const controls = latestInputControls(messages);
        setIsInputDisabled(controls.disabled);
        setBloqueiaInputLetras(controls.numeric);
    }, [messages]);

    const checkTimerStateOnUserMessage = (messageText) => {
        if (!messageText || typeof messageText !== 'string') return;
        
        // Detectar seleção de data/horário do calendário para iniciar o timer
        const isTimeSelection = /\(\d{2}\/\d{2}\)/.test(messageText) && /\d{2}:\d{2}/.test(messageText);
            
        if (isTimeSelection) {
            console.log("⏰ Seleção de horário detectada! Iniciando timer de confirmação...");
            const durationMs = 600 * 1000; // 10 minutos
            timerEndTimeRef.current = Date.now() + durationMs;
            warningFiredRef.current = false;
            setTimerSeconds(600);
            setTimerActive(true);
            setIsBookingTimeExpired(false);
            setShowWarningModal(false);
            setShowExpiredModal(false);
        }

        // Detectar se o agendamento foi finalizado ou se foi cancelado/editado
        const isFinalConfirmation = !!messageText.match(/confirmar.*agendamento/i) || 
            !!messageText.match(/agendamento.*confirmad/i) ||
            !!messageText.match(/finalizar.*agendamento/i) ||
            messageText.toLowerCase() === 'confirmar agendamento';
            
        const isCancellationOrEdit = !!messageText.match(/editar.*informa/i) || 
            !!messageText.match(/editar.*horario/i) ||
            !!messageText.match(/editar.*agendamento/i) ||
            !!messageText.match(/cancelar.*agendamento/i) ||
            !!messageText.match(/voltar.*horario/i) || 
            messageText === 'Reiniciar Atendimento';

        if (isFinalConfirmation || isCancellationOrEdit) {
            console.log("⏰ Finalização ou cancelamento detectado! Parando timer...");
            setTimerActive(false);
            setTimerSeconds(null);
            setIsBookingTimeExpired(false);
            setShowWarningModal(false);
        }
    };

    const handleTimerExpiration = () => {
        setTimerActive(false);
        setTimerSeconds(null);
        setIsBookingTimeExpired(true);
        setShowWarningModal(false);
        setShowExpiredModal(true);
    };

    const handleCloseExpiredModal = () => {
        setShowExpiredModal(false);
    };

    const handleCloseWarningModal = () => {
        setShowWarningModal(false);
    };

    const formatTime = (seconds) => {
        if (seconds === null) return '00:00';
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    };

    useEffect(() => {
        let interval = null;
        if (timerActive && timerSeconds !== null && timerSeconds > 0) {
            interval = setInterval(() => {
                if (!timerEndTimeRef.current) return;

                // Calcula o tempo restante real com base no timestamp absoluto.
                // Isso garante que pausas do browser (segundo plano / throttle)
                // não desincronizem a contagem.
                const remaining = Math.round((timerEndTimeRef.current - Date.now()) / 1000);

                if (remaining <= 0) {
                    clearInterval(interval);
                    handleTimerExpiration();
                    setTimerSeconds(0);
                    return;
                }

                // Alerta quando restar exatamente 2 minutos (120 segundos)
                if (remaining <= 120 && !warningFiredRef.current) {
                    warningFiredRef.current = true;
                    setShowWarningModal(true);
                }

                setTimerSeconds(remaining);
            }, 1000);
        }
        return () => {
            if (interval) clearInterval(interval);
        };
    }, [timerActive]);

    // Inicializar chat: verificar histórico das últimas 24h antes de fazer startChat
    useEffect(() => {
        const marca = searchParams.get('marca');
        const origem = searchParams.get('origem');
        const client_id = searchParams.get('client_id');
        const operational_system = searchParams.get('operational_system');
        const version_app = searchParams.get('version_app');

        const historicoParam = searchParams.get('historico');

        // Para SDK: histórico desabilitado por padrão (só ativa se passar disable_history=false ou historico=true)
        // Para Web normal: histórico ativo por padrão (comportamento original, só desativa se historico=false ou disable_history=true)
        let historico_ativo;
        if (isSdk) {
            historico_ativo = disableHistoryParam === 'false' || historicoParam === 'true';
        } else {
            historico_ativo = historicoParam !== 'false' && disableHistoryParam !== 'true';
        }

        const isHistoryDisabledByWindow = typeof window !== 'undefined' && (
            window.disable_history === true ||
            window.disable_history === 'true' ||
            window.disableHistory === true ||
            window.disableHistory === 'true' ||
            window.fleuryChatConfig?.disable_history === true ||
            window.fleuryChatConfig?.disable_history === 'true' ||
            window.fleuryChatConfig?.disableHistory === true ||
            window.fleuryChatConfig?.disableHistory === 'true'
        );

        if (isHistoryDisabledByWindow) {
            historico_ativo = false;
        }

        try {
            if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('restart_chat_initial_menu') === 'true') {
                sessionStorage.removeItem('restart_chat_initial_menu');
                historico_ativo = false;
                console.log('🔄 Reinício manual para o Menu Inicial detectado. Histórico desativado para esta inicialização.');
            }
        } catch (e) {
            console.error('Erro ao verificar flag restart_chat_initial_menu:', e);
        }

        console.log('🔍 Parâmetros do startChat:', { marca, origem, client_id, operational_system, version_app, historico_ativo, isSdk, location });

        const initChat = async () => {
            // Se NÃO for SDK e já existirem mensagens no estado (o usuário apenas minimizou/reabriu o widget),
            // mantém a conversa atual na tela sem reiniciar
            if (!isSdk && messages && messages.length > 0) {
                console.log('ℹ️ Chat reaberto no Web normal: mantendo mensagens atuais na tela.');
                return;
            }

            const cid = client_id || 'web-default';
            const marc = marca || 'fleury';
            const orig = origem || 'web';

            // 1. Verificar se existe sessão ativa nas últimas 24h
            let latest = null;
            if (historico_ativo) {
                latest = await checkLatestConversation(cid, marc, orig);
            } else {
                console.log('⏭️ Busca de histórico desabilitada via URL ou SDK (disable_history=true).');
            }

            // 2. Se a sessão não expirou, tentar recuperar o histórico
            if (latest && latest.found && !latest.expired && latest.conversationId) {
                console.log('🔄 Sessão ativa encontrada, recuperando histórico...', latest.conversationId);

                await initializeFeatureFlagsCache(cid);
                const resumed = await resumeConversation(cid, latest.conversationId, marc, orig);

                if (resumed && resumed.messages && resumed.messages.length > 0) {
                    console.log('✅ Histórico carregado:', resumed.messages.length, 'mensagens');

                    // Salvar session_id para o sendMessage continuar a sessão correta
                    if (latest.session_id) {
                        try { window.currentSessionId = latest.session_id; } catch (e) { }
                    }
                    if (latest.conversationId) {
                        try { window.currentConversationId = latest.conversationId; } catch (e) { }
                    }

                    // Restaurar os IDs necessários do último contexto recuperado para o frontend state/window
                    try {
                        const turns = resumed.rawData?.turns;
                        if (turns && turns.length > 0) {
                            const lastTurn = turns[turns.length - 1];
                            const contextSlots = lastTurn?.context?.slots || {};

                            if (contextSlots.requisicaoAgendamento) {
                                setRequestId(String(contextSlots.requisicaoAgendamento));
                                if (typeof window !== 'undefined') window.currentRequestId = String(contextSlots.requisicaoAgendamento);
                            }
                            if (contextSlots.idFluxoAgendamento) {
                                if (typeof window !== 'undefined') window.currentIdFluxoAgendamento = String(contextSlots.idFluxoAgendamento);
                            }
                            if (contextSlots.clienteSexo) {
                                if (typeof window !== 'undefined') window.currentClienteSexo = String(contextSlots.clienteSexo).trim().toUpperCase();
                            }
                            if (contextSlots.person) {
                                if (typeof window !== 'undefined') {
                                    window.currentPerson = contextSlots.person;
                                    const maybeCustomer = contextSlots.person?.customer || contextSlots.person?.custumer || null;
                                    if (maybeCustomer) window.currentCustomer = maybeCustomer;
                                }
                            }
                            if (contextSlots.cliente) {
                                if (typeof window !== 'undefined') window.currentCustomer = contextSlots.cliente;
                            }
                            if (contextSlots.unidadeSelecionada) {
                                if (typeof window !== 'undefined') window.currentUnidadeSelecionada = String(contextSlots.unidadeSelecionada);
                            }
                        }
                    } catch (e) {
                        console.error('Erro ao restaurar variáveis de contexto:', e);
                    }

                    // Inserir nosso próprio botão solto ao final da conversa
                    const finalMessages = [...resumed.messages];
                    finalMessages.push({
                        origin: 'bot',
                        isRestartButton: true,
                        buttonLinkText: 'Reiniciar Atendimento'
                    });

                    setMessages(finalMessages);
                    return;
                }

                console.log('⚠️ Histórico vazio ou falhou, iniciando nova sessão...');
            } else {
                console.log('ℹ️ Nenhuma sessão ativa encontrada, iniciando nova...');
            }

            // 3. Fluxo padrão: iniciar conversa do zero
            console.log('✅ Executando startChat normalmente');
            const newConversationId = uuidv4();
            try { window.currentConversationId = newConversationId; } catch (e) { }
            if (isSdk) {
                setMessages([]);
            }
            startChat(
                isSdk ? [] : messages,
                setMessages,
                cid,
                marc,
                orig,
                operational_system || 'web',
                version_app || '1.0',
                location,
                location?.lat || '',
                location?.long || '',
                requestLocation,
                requestImage,
                setRequestId,
                newConversationId
            );
        };

        initChat();

        return () => {
            // Limpar mensagens e variáveis de sessão globais ao desmontar APENAS se for SDK
            if (isSdk) {
                setMessages([]);
                if (typeof window !== 'undefined') {
                    window.currentConversationId = null;
                    window.currentSessionId = null;
                    window.currentRequestId = null;
                    window.currentIdFluxoAgendamento = null;
                    window.currentInsuranceSelected = null;
                    window.currentCarterinhaManual = null;
                    window.currentPerson = null;
                    window.currentCustomer = null;
                    window.currentClienteSexo = null;
                    window.currentUnidadeSelecionada = null;
                }
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Executar apenas uma vez quando o componente for montado

    // Escutador de mensagens de Webhook em tempo real via SSE (Server-Sent Events)
    useEffect(() => {
        const urlClientId = (typeof window !== 'undefined' && window.location)
            ? (new URLSearchParams(window.location.search).get('client_id') || client_id || '')
            : (client_id || '');

        const isMarca0106 = searchParams.get('marca') === '0106';
        const targetSSEClientId = client_id || urlClientId || (isMarca0106 ? '16513932' : null);

        const stopSSEListener = startWebhookSSEListener({
            clientId: targetSSEClientId,
            flowSessionId: getWebhookConversationId,
            altClientId: isMarca0106 ? '16513932' : null,
            sessionId: (typeof window !== 'undefined' ? window.currentSessionId : null) || uuid,
            onMessageReceived: acceptWebhookMessage
        });

        return () => {
            if (stopSSEListener) stopSSEListener();
        };
    }, [client_id, searchParams, acceptWebhookMessage, uuid]);

    // Função para mostrar o CSAT após um tempo definido
    const startCSATTimer = () => {
        const paymentModalOpen = (() => {
            try {
                return typeof window !== 'undefined' && window.isPaymentModalOpen === true;
            } catch (e) {
                return false;
            }
        })();

        // Se a modal de pagamento estiver aberta, só iniciar o timer após o fechamento dela
        if (paymentModalOpen) {
            csatPendingAfterPaymentRef.current = true;
            // Garantir que CSAT não apareça por cima do pagamento
            setShowCSAT(false);
            if (csatTimeoutRef.current) {
                clearTimeout(csatTimeoutRef.current);
                csatTimeoutRef.current = null;
            }
            setCsatTimeout(null);
            return;
        }

        // Limpa qualquer timer existente
        if (csatTimeoutRef.current) {
            clearTimeout(csatTimeoutRef.current);
            csatTimeoutRef.current = null;
        }

        console.log(`CSAT será exibido em ${csatDisplayTimeout}ms`);

        // Define novo timer
        const timer = setTimeout(() => {
            // Se a modal de pagamento abrir enquanto contamos, seguramos o CSAT para depois
            try {
                if (typeof window !== 'undefined' && window.isPaymentModalOpen === true) {
                    csatPendingAfterPaymentRef.current = true;
                    setShowCSAT(false);
                    return;
                }
            } catch (e) {
                // ignore
            }
            console.log('Exibindo CSAT agora');
            setShowCSAT(true);
        }, csatDisplayTimeout);

        csatTimeoutRef.current = timer;
        setCsatTimeout(timer);
    };

    startCSATTimerRef.current = startCSATTimer;

    // Bloquear CSAT enquanto pagamento estiver aberto e só iniciar após fechar
    useEffect(() => {
        const onPaymentOpened = () => {
            // Fechar CSAT se estiver aberto e cancelar timer
            setShowCSAT(false);
            // Se já existia timer rodando ou CSAT aberto, marcar para retomar após fechar
            if (csatTimeoutRef.current || showCSAT) {
                csatPendingAfterPaymentRef.current = true;
            }
            try {
                if (csatTimeoutRef.current) {
                    clearTimeout(csatTimeoutRef.current);
                    csatTimeoutRef.current = null;
                }
            } catch (e) {
                // ignore
            }
            setCsatTimeout(null);
        };

        const onPaymentClosed = () => {
            if (csatPendingAfterPaymentRef.current) {
                csatPendingAfterPaymentRef.current = false;
                // Iniciar timer somente após fechamento do pagamento
                if (typeof startCSATTimerRef.current === 'function') {
                    startCSATTimerRef.current();
                }
            }
        };

        try {
            if (typeof window !== 'undefined') {
                window.addEventListener('payment-modal-opened', onPaymentOpened);
                window.addEventListener('payment-modal-closed', onPaymentClosed);
            }
        } catch (e) {
            // ignore
        }

        return () => {
            try {
                if (typeof window !== 'undefined') {
                    window.removeEventListener('payment-modal-opened', onPaymentOpened);
                    window.removeEventListener('payment-modal-closed', onPaymentClosed);
                }
            } catch (e) {
                // ignore
            }
        };
    }, []);

    // Limpa o timer quando o componente é desmontado
    useEffect(() => {
        return () => {
            // Importante: este cleanup roda também quando csatTimeout muda (por causa do dependency array),
            // então devemos limpar o timer anterior (state), não o "current" (ref), para não cancelar o novo timer.
            if (csatTimeout) {
                clearTimeout(csatTimeout);
            }
            csatTimeoutRef.current = null;
        };
    }, [csatTimeout]);

    // Função para lidar com o fechamento do CSAT
    const handleCSATClose = (response) => {
        setShowCSAT(false);

        // Obter client_id
        const client_id = searchParams.get('client_id') || (newIdd !== '' ? newIdd : client_recebido);

        // Obter informações de autoservice da última mensagem do bot, se disponível
        let autoservice = "";
        if (messages.length > 0) {
            const lastBotMessage = [...messages].reverse().find(msg => msg.origin === 'bot');
            if (lastBotMessage && lastBotMessage.autoservice) {
                autoservice = lastBotMessage.autoservice;
            }
        }

        // Verificar se é uma resposta completa (objeto) ou apenas uma string
        if (typeof response === 'object') {
            if (response.response === 'não') {
                // Feedback negativo com avaliação e comentário
                sendCSATFeedback({
                    client_id,
                    response: 'não',
                    feedback: response.feedback,
                    rating: response.rating, // Incluindo o rating para respostas negativas
                    uuid: uuid, // Usando o UUID já existente do componente
                    autoservice
                });

                // Adicionar mensagem de agradecimento
                setMessages(messages => [...messages, {
                    origin: 'bot',
                    response: 'Obrigado pelo seu feedback! Vamos trabalhar para melhorar sua experiência.',
                    options: [],
                    bloqueiaInput: false,
                    desativaFeedbackPorMensagem: true // Desativar feedback para mensagens de agradecimento
                }]);
            } else if (response.response === 'sim') {
                // Feedback positivo com avaliação por emoji
                sendCSATFeedback({
                    client_id,
                    response: 'sim',
                    feedback: response.feedback,
                    rating: response.rating,
                    uuid: uuid, // Usando o UUID já existente do componente
                    autoservice
                });

                // Adicionar mensagem de agradecimento
                setMessages(messages => [...messages, {
                    origin: 'bot',
                    response: 'Obrigado pela sua avaliação! Estamos felizes em poder ajudar.',
                    options: [],
                    bloqueiaInput: false,
                    desativaFeedbackPorMensagem: true // Desativar feedback para mensagens de agradecimento
                }]);
            }
        } else if (response === 'sim' || response === 'não') {
            // Resposta simples sem feedback adicional
            sendCSATFeedback({
                client_id,
                response,
                uuid: uuid,
                autoservice
            });
        }
    };

    // Função para limpar completamente todos os estados do OCR
    const clearAllOCRStates = () => {
        console.log('🧹🧹🧹 LIMPEZA COMPLETA DE TODOS OS ESTADOS OCR 🧹🧹🧹');
        console.log('Estados antes da limpeza:', {
            currentOcrType: window.currentOcrType,
            currentIdPessoaFisica: window.currentIdPessoaFisica,
            isPollingActive: window.isPollingActive,
            currentOcrExamesCount: window.currentOcrExamesCount,
            currentInsuranceSelected: window.currentInsuranceSelected,
            currentRequestId: window.currentRequestId
        });

        // Limpar todas as variáveis do window
        window.currentOcrType = null;
        window.currentOcrProvider = null;
        window.currentIdPessoaFisica = null;
        window.isPollingActive = false;
        window.currentInsuranceSelected = null;
        window.cancelCurrentOcrPolling = false;
        window.currentCarterinhaManual = undefined;
        window.ocrExamesBaselineCount = 0;

        console.log('✅ TODOS os estados OCR foram limpos e resetados');
    };

    // Função para limpar estado após polling
    const clearPollingState = (resetExamesCounter = false) => {
        // Limpar dados relacionados ao processamento atual
        console.log('🧹 Limpando estado do polling...');
        console.log('   - window.currentOcrType:', window.currentOcrType);
        console.log('   - window.currentIdPessoaFisica:', window.currentIdPessoaFisica);
        console.log('   - window.isPollingActive:', window.isPollingActive);
        console.log('   - window.currentOcrExamesCount:', window.currentOcrExamesCount);
        console.log('   - resetExamesCounter:', resetExamesCounter);

        const currentType = window.currentOcrType;

        window.currentOcrType = null;
        window.currentOcrProvider = null;
        window.currentIdPessoaFisica = null;
        window.isPollingActive = false; // Liberar flag de polling

        // Resetar contador de OCR de exames apenas se for de exames e resetExamesCounter for true
        if (resetExamesCounter && (currentType === 'normal' || currentType === 'pedido-medico')) {
            console.log('🔄 Resetando contador de OCR de exames');
            window.currentOcrExamesCount = 0;
            setOcrExamesCount(0);
            window.ocrExamesBaselineCount = 0;
        }

        console.log('✅ Estado de polling limpo para permitir novo processamento');
    };

    // Função para consultar API de OCR até obter o payload
    const pollAPIForOCRPayload = async (providedRequestId, ocrTypeContext = null, expectedOcrExamesCount = 1) => {
        console.log('🆕 ========== NOVA CHAMADA DE POLLING ==========');
        console.log('   requestId:', providedRequestId);
        console.log('   ocrTypeContext:', ocrTypeContext);
        console.log('   expectedOcrExamesCount:', expectedOcrExamesCount);
        console.log('   window.isPollingActive:', window.isPollingActive);
        console.log('   window.currentOcrType:', window.currentOcrType);
        console.log('===============================================');

        // Se alguém marcou cancelamento explícito (por exemplo, após "no-image-received"),
        // não iniciamos um novo polling.
        if (window.cancelCurrentOcrPolling) {
            const shouldResetCounter = (ocrTypeContext === 'normal' || ocrTypeContext === 'pedido-medico');
            console.log('🛑 Polling NÃO iniciado porque foi cancelado externamente.', {
                providedRequestId,
                ocrTypeContext,
                cancelCurrentOcrPolling: window.cancelCurrentOcrPolling
            });
            clearPollingState(shouldResetCounter);
            window.cancelCurrentOcrPolling = false;
            return;
        }

        if (!providedRequestId) {
            console.error('❌ RequestId não fornecido para polling da API');
            return;
        }

        // Prevenir múltiplos pollings simultâneos
        if (window.isPollingActive) {
            console.log('⚠️ Polling já está ativo, ignorando nova chamada', { ocrTypeContext, providedRequestId });
            return;
        }
        window.isPollingActive = true;

        const maxAttempts = ocrMaxAttempts;
        let attempts = 0;
        let ocrProcessed = false; // Flag para evitar duplicação

        console.log('🔍 Iniciando polling API para requestId:', providedRequestId, { ocrTypeContext, expectedOcrExamesCount });

        const pollLoop = async () => {
            if (ocrProcessed) {
                return true;
            }

            // Verificar se o polling foi cancelado externamente (ex.: após enviar "no-image-received")
            if (window.cancelCurrentOcrPolling) {
                const shouldResetCounter = (ocrTypeContext === 'normal' || ocrTypeContext === 'pedido-medico');
                console.log('🛑 Polling interrompido porque cancelCurrentOcrPolling = true.', {
                    ocrTypeContext,
                    attempts,
                    providedRequestId
                });
                clearPollingState(shouldResetCounter);
                window.cancelCurrentOcrPolling = false;
                return false;
            }

            if (attempts >= maxAttempts) {
                const shouldResetCounter = (ocrTypeContext === 'normal' || ocrTypeContext === 'pedido-medico');
                clearPollingState(shouldResetCounter); // Limpar estado e resetar contador se for de exames
                console.log('⏱️ Timeout do polling API atingido', { ocrTypeContext, attempts, providedRequestId, resetCounter: shouldResetCounter });

                // Tratar timeout específico por tipo (somente se não foi processado ainda)
                if (ocrTypeContext === 'ocr-carteirinha' && !ocrProcessed) {
                    // Abrir componente de convênio manual
                    const preselectedId = (window.currentInsuranceSelected && window.currentInsuranceSelected.insurance && window.currentInsuranceSelected.insurance.id) ? String(window.currentInsuranceSelected.insurance.id) : '';
                    setMessages(prev => {
                        const lastIsTyping = prev.length > 0 && (prev[prev.length - 1]?.typing === true || (prev[prev.length - 1]?.origin === 'bot' && prev[prev.length - 1]?.response === 'Digitando...'));
                        return lastIsTyping ? prev.slice(0, -1) : prev;
                    });
                    setMessages(prev => [...prev, {
                        origin: 'bot',
                        response: 'Não conseguimos identificar os dados da sua carteirinha. Vamos seguir com o preenchimento manual',
                        options: [],
                        ...getLatestButtonLink(prev),
                        componenteConvenio: true,
                        preselectedInsuranceId: preselectedId,
                        forceManualConvenioFlow: true,
                        desativaFeedbackPorMensagem: { desativaFeedbackPorMensagem: true, componenteConvenio: true }
                    }]);
                } else if ((ocrTypeContext === 'pedido-medico' || ocrTypeContext === 'normal') && !ocrProcessed) {
                    // Timeout do OCR de exames: aqui é exatamente o momento em que precisamos avisar o backend
                    // que nenhum exame foi reconhecido.
                    console.log('⚠️ Timeout OCR de exames. Enviando "no-exams-received" para o backend.');

                    const marca = searchParams.get('marca') || 'AM';
                    const origem = searchParams.get('origem') || 'chat-web';
                    const currentClientId = newIdd !== '' ? newIdd : client_id;
                    setOcrExamesCount(prev => {
                        const newCount = prev - 1;
                        console.log(' 📉 Decrementando contador de OCR de exames (por tentativa com erro):', {
                            anterior: prev,
                            novo: newCount
                        });
                        window.currentOcrExamesCount = newCount; // Guardar também no window para acesso global
                        return newCount;
                    });

                    sendMessage(
                        setMessages,
                        currentClientId,
                        'no-exams-received',
                        messages,
                        marca,
                        origem,
                        null,
                        location,
                        location.lat,
                        location.long,
                        null,
                        setTeste2,
                        requestLocation,
                        sistema,
                        versao,
                        null,
                        null,
                        requestImage,
                        setRequestId
                    );
                }

                return false; // Timeout
            }

            attempts++;
            console.log(`📡 Tentativa ${attempts}/${maxAttempts} - Consultando API OCR...`);
            
            // Montar parâmetros adicionais para o get-ocr-payload:
            // - sexo (M/F) quando disponível
            // - brandInitials e regional iguais aos usados em BuscaExames (AM / SP)
            let extraQueryParams = '&brandInitials=AM&regional=SP';
            try {
                if (typeof window !== 'undefined' && typeof window.currentClienteSexo === 'string') {
                    const sexo = window.currentClienteSexo.trim().toUpperCase();
                    if (sexo === 'M' || sexo === 'F') {
                        extraQueryParams += `&sexo=${encodeURIComponent(sexo)}`;
                    }
                }
            } catch (e) {
                console.log('⚠️ Não foi possível ler window.currentClienteSexo', e);
            }
            
            try {
                const response = await fetch(`${apiBaseUrl}/get-ocr-payload?requestId=${providedRequestId}${extraQueryParams}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    console.log(`⚠️ API retornou status ${response.status}, aguardando ${ocrPollingIntervalMs / 1000} segundos para nova tentativa...`);
                    await new Promise(resolve => setTimeout(resolve, ocrPollingIntervalMs));
                    return await pollLoop();
                }

                const apiResponse = await response.json();
                console.log('📩 API OCR resposta completa recebida', {
                    requestId: apiResponse?.requestId,
                    hasData: !!apiResponse?.data,
                    dataLength: apiResponse?.data?.length,
                    ocrTypeContext
                });

                // Validar se a resposta corresponde ao requestId esperado
                const messageRequestId = String(apiResponse?.requestId || '').trim();
                const currentRequestId = String(providedRequestId || '').trim();

                if (messageRequestId !== currentRequestId) {
                    console.log('⚠️ RequestId da resposta não corresponde ao esperado', { messageRequestId, currentRequestId });
                    await new Promise(resolve => setTimeout(resolve, ocrPollingIntervalMs));
                    return await pollLoop();
                }

                // Verificar se tem array data
                if (!apiResponse?.data || !Array.isArray(apiResponse.data) || apiResponse.data.length === 0) {
                    console.log(`⚠️ Resposta sem dados ou incompleta, aguardando ${ocrPollingIntervalMs / 1000} segundos...`);
                    await new Promise(resolve => setTimeout(resolve, ocrPollingIntervalMs));
                    return await pollLoop();
                }

                console.log('📦 Processando array data com', apiResponse.data.length, 'item(s)');

                // Buscar o item específico do tipo que estamos procurando
                let corpo = null;
                if (ocrTypeContext === 'ocr-carteirinha') {
                    corpo = apiResponse.data.find(item => item.type === 'ocr-carteirinha');
                    console.log('🔍 Buscando OCR Carteirinha no array data:', !!corpo);
                } else if (ocrTypeContext === 'pedido-medico' || ocrTypeContext === 'normal') {
                    corpo = apiResponse.data.find(item => item.type === 'ocr');
                    console.log('🔍 Buscando OCR de Exames no array data:', !!corpo);
                }

                // Se não encontrou o tipo esperado, aguardar mais
                if (!corpo) {
                    console.log('⚠️ Tipo de OCR esperado não encontrado no array data', {
                        ocrTypeContext,
                        typesInData: apiResponse.data.map(item => item.type)
                    });
                    await new Promise(resolve => setTimeout(resolve, ocrPollingIntervalMs));
                    return await pollLoop();
                }

                console.log('✅ Item encontrado no array data:', { type: corpo.type, requestId: corpo.requestId });

                // Processar payload do OCR de exames
                if (corpo.type === 'ocr' && corpo.exams && corpo.exams.length > 0) {
                    console.log('✅ Exames recebidos da API OCR', { count: corpo.exams.length });

                    // Verificar quantidadeRespostasExames considerando o baseline
                    // O baseline representa quantas respostas já existiam ANTES do novo envio
                    const quantidadeRespostasExames = corpo.quantidadeRespostasExames || 1;
                    const baseline = window.ocrExamesBaselineCount || 0;
                    const totalExpected = expectedOcrExamesCount + baseline;
                    console.log('📊 Verificação de respostas de exames (com baseline):', {
                        quantidadeRespostasExames,
                        baseline,
                        expectedOcrExamesCount,
                        totalExpected,
                        todasRespostasRecebidas: quantidadeRespostasExames >= totalExpected
                    });

                    // Se ainda não recebemos todas as respostas esperadas (incluindo baseline), continuar polling
                    if (quantidadeRespostasExames < totalExpected) {
                        console.log('⏳ Aguardando mais respostas de exames...', {
                            recebidas: quantidadeRespostasExames,
                            esperadas: totalExpected,
                            baseline,
                            faltam: totalExpected - quantidadeRespostasExames
                        });
                        await new Promise(resolve => setTimeout(resolve, ocrPollingIntervalMs));
                        return await pollLoop();
                    }

                    console.log('✅ Todas as respostas de exames foram recebidas!');

                    const examesSelecionados = {
                        procedimentos: corpo.exams.map(exam => ({
                            id: String(exam.id),
                            nome: exam.name,
                            valor: parseFloat(exam.price) || 0,
                            hasMobileCoverage: exam.hasMobileCoverage || false,
                            hasUnitCoverage: exam.hasUnitCoverage || false
                        })),
                        valorTotal: corpo.valorTotal || corpo.exams.reduce((total, exam) => {
                            return total + (parseFloat(exam.price) || 0);
                        }, 0),
                        procedimentosRemoved: corpo.procedimentosRemoved || null
                    };

                    if (corpo.requestId) {
                        const newReqId = String(corpo.requestId);
                        console.log('🔑 Atualizando requestId do corpo:', newReqId);
                        setRequestId(newReqId);
                        window.currentRequestId = newReqId;
                    }

                    const marca = searchParams.get('marca') || 'AM';
                    const origem = searchParams.get('origem') || 'chat-web';
                    const currentClientId = newIdd !== '' ? newIdd : client_id;

                    console.log('📤 Enviando exames selecionados para sendMessage');

                    sendMessage(
                        setMessages,
                        currentClientId,
                        '',
                        messages,
                        marca,
                        origem,
                        null,
                        location,
                        location.lat,
                        location.long,
                        null,
                        setTeste2,
                        requestLocation,
                        sistema,
                        versao,
                        examesSelecionados,
                        null,
                        requestImage,
                        setRequestId
                    );

                    ocrProcessed = true;

                    // Limpar TODOS os estados após processar com sucesso
                    console.log('🎯 Processamento de exames concluído, limpando todos os estados');
                    clearAllOCRStates();
                    return true;

                } else if (corpo.type === 'ocr' && (!corpo.exams || corpo.exams.length === 0) && corpo.procedimentosRemoved && corpo.procedimentosRemoved.length > 0) {
                    console.log('✅ Apenas procedimentos removidos recebidos da API OCR');

                    const examesSelecionados = {
                        procedimentos: [],
                        valorTotal: 0,
                        procedimentosRemoved: corpo.procedimentosRemoved.map(item => ({
                            id: String(item.id),
                            nome: item.name,
                            valor: parseFloat(item.price) || 0,
                            hasMobileCoverage: item.hasMobileCoverage || false,
                            hasUnitCoverage: item.hasUnitCoverage || false
                        }))
                    };

                    if (corpo.requestId) {
                        const newReqId = String(corpo.requestId);
                        console.log('🔑 Atualizando requestId do corpo:', newReqId);
                        setRequestId(newReqId);
                        window.currentRequestId = newReqId;
                    }

                    const marca = searchParams.get('marca') || 'AM';
                    const origem = searchParams.get('origem') || 'chat-web';
                    const currentClientId = newIdd !== '' ? newIdd : client_id;

                    console.log('📤 Enviando procedimentos removidos para sendMessage');

                    sendMessage(
                        setMessages,
                        currentClientId,
                        '',
                        messages,
                        marca,
                        origem,
                        null,
                        location,
                        location.lat,
                        location.long,
                        null,
                        setTeste2,
                        requestLocation,
                        sistema,
                        versao,
                        examesSelecionados,
                        null,
                        requestImage,
                        setRequestId
                    );

                    ocrProcessed = true;

                    // Limpar TODOS os estados após processar com sucesso
                    console.log('🎯 Processamento de procedimentos removidos concluído, limpando todos os estados');
                    clearAllOCRStates();
                    return true;

                } else if (corpo.type === 'ocr-carteirinha') {
                    console.log('🪪 API OCR Carteirinha detectado');
                    console.log('📦 Dados recebidos:', JSON.stringify(corpo, null, 2));

                    const hi = corpo.healthInsurance || {};
                    const failMessage = corpo?.message && typeof corpo.message === 'string';
                    const ocrReadArr = Array.isArray(hi.ocrRead) ? hi.ocrRead : [];
                    const cepArr = Array.isArray(hi.zipCode || hi.cep) ? (hi.zipCode || hi.cep) : [];
                    const ocrRead = ocrReadArr.length > 0 ? ocrReadArr[0] : {};
                    const cep = cepArr.length > 0 ? cepArr[0] : {};

                    console.log('📋 ocrRead:', JSON.stringify(ocrRead, null, 2));
                    console.log('📋 cep:', JSON.stringify(cep, null, 2));
                    console.log('🔎 Acessando dados do cep:');
                    console.log('   cep.insuranceId:', cep.insuranceId);
                    console.log('   cep.insuranceId?.id:', cep.insuranceId?.id);
                    console.log('   cep.insuranceId?.name:', cep.insuranceId?.name);
                    console.log('   cep.companyId:', cep.companyId);
                    console.log('   cep.companyId?.id:', cep.companyId?.id);
                    console.log('   cep.companyId?.name:', cep.companyId?.name);
                    console.log('   cep.planId:', cep.planId);
                    console.log('   cep.planId?.id:', cep.planId?.id);
                    console.log('   cep.planId?.name:', cep.planId?.name);

                    // Buscar examesSelecionados da última mensagem de convênio (se existir),
                    // para reaproveitar o filtro de exames na reabertura manual do componente.
                    let previousExamesSelecionados = null;
                    try {
                        if (Array.isArray(messages)) {
                            const lastConvenioMsg = [...messages].reverse().find(msg =>
                                msg?.componenteConvenio === true ||
                                msg?.desativaFeedbackPorMensagem?.componenteConvenio === true
                            );
                            if (lastConvenioMsg && lastConvenioMsg.examesSelecionados) {
                                previousExamesSelecionados = lastConvenioMsg.examesSelecionados;
                            }
                        }
                    } catch (e) {
                        console.error('Erro ao recuperar examesSelecionados da última mensagem de convênio:', e);
                    }

                    const onlyDigits = (str) => (str || '').toString().replace(/\D+/g, '');

                    // Validar se temos dados mínimos necessários
                    const hasMinimumData = (cep?.insuranceId?.id || ocrRead?.insurance) &&
                        (cep?.companyId?.id || ocrRead?.company) &&
                        (cep?.planId?.id || ocrRead?.plan);

                    if (!hasMinimumData) {
                        console.log('⚠️ Dados insuficientes na carteirinha');
                        const preselectedId = (window.currentInsuranceSelected && window.currentInsuranceSelected.insurance && window.currentInsuranceSelected.insurance.id) ? String(window.currentInsuranceSelected.insurance.id) : '';

                        setMessages(prev => {
                            const lastIsTyping = prev.length > 0 && (prev[prev.length - 1]?.typing === true || (prev[prev.length - 1]?.origin === 'bot' && prev[prev.length - 1]?.response === 'Digitando...'));
                            return lastIsTyping ? prev.slice(0, -1) : prev;
                        });
                        setMessages(prev => [...prev, {
                            origin: 'bot',
                            response: 'Não conseguimos identificar os dados da sua carteirinha. Vamos seguir com o preenchimento manual',
                            options: [],
                            ...getLatestButtonLink(prev),
                            componenteConvenio: true,
                            preselectedInsuranceId: preselectedId,
                            forceManualConvenioFlow: true,
                            examesSelecionados: previousExamesSelecionados,
                            desativaFeedbackPorMensagem: { desativaFeedbackPorMensagem: true, componenteConvenio: true }
                        }]);

                        ocrProcessed = true;

                        // Limpar estados após erro de dados insuficientes
                        console.log('🎯 Dados insuficientes, limpando estados do polling');
                        clearPollingState(false);
                        return true;
                    }

                    const insuranceSelected = {
                        insurance: {
                            id: String(cep?.insuranceId?.id || ''),
                            name: String(cep?.insuranceId?.name || ocrRead?.insurance || '')
                        },
                        company: {
                            id: String(cep?.companyId?.id || ''),
                            name: String(cep?.companyId?.name || ocrRead?.company || '')
                        },
                        plan: {
                            id: String(cep?.planId?.id || ''),
                            name: String(cep?.planId?.name || ocrRead?.plan || '')
                        },
                        card: {
                            number: onlyDigits(ocrRead?.cardNumber || ''),
                            ValidThru: String(ocrRead?.validThru || '')
                        },
                        isManual: false
                    };


                    if (corpo.requestId) {
                        setRequestId(String(corpo.requestId));
                    }

                    // Timeout pendente de "no-image-received" não é mais necessário sem o timer

                    // Validar se o convênio retornado é diferente do enviado
                    const originalInsuranceId = (window.currentInsuranceSelected && window.currentInsuranceSelected.insurance && window.currentInsuranceSelected.insurance.id) ? String(window.currentInsuranceSelected.insurance.id) : '';
                    const originalInsuranceName = (window.currentInsuranceSelected && window.currentInsuranceSelected.insurance && window.currentInsuranceSelected.insurance.name) ? String(window.currentInsuranceSelected.insurance.name) : '';
                    const ocrInsuranceId = String(cep?.insuranceId?.id || '');
                    const ocrInsuranceName = String(cep?.insuranceId?.name || ocrRead?.insurance || '');

                    // Helper para normalizar nome
                    const normalizeName = (str) => (str || '').toLowerCase().trim().replace(/\s+/g, ' ').replace(/[^\w\s]/g, '');
                    const originalNorm = normalizeName(originalInsuranceName);
                    const ocrNorm = normalizeName(ocrInsuranceName);

                    const idMismatch = originalInsuranceId && ocrInsuranceId && (originalInsuranceId !== ocrInsuranceId);
                    const nameMismatch = originalNorm && ocrNorm && !ocrNorm.includes(originalNorm) && !originalNorm.includes(ocrNorm);
                    const insuranceMismatch = idMismatch && nameMismatch;



                    if (failMessage || insuranceMismatch) {
                        const preselectedId = originalInsuranceId;
                        const msgText = failMessage
                            ? 'Não conseguimos identificar os dados da sua carteirinha. Vamos seguir com o preenchimento manual'
                            : 'O convênio identificado na carteirinha não corresponde ao selecionado. Por favor, confirme os dados.';

                        console.log('❌ Falha ou divergência detectada, abrindo componente manual');

                        setMessages(prev => {
                            const lastIsTyping = prev.length > 0 && (prev[prev.length - 1]?.typing === true || (prev[prev.length - 1]?.origin === 'bot' && prev[prev.length - 1]?.response === 'Digitando...'));
                            return lastIsTyping ? prev.slice(0, -1) : prev;
                        });
                        setMessages(prev => [...prev, {
                            origin: 'bot',
                            response: msgText,
                            options: [],
                            ...getLatestButtonLink(prev),
                            componenteConvenio: true,
                            preselectedInsuranceId: preselectedId,
                            forceManualConvenioFlow: true,
                            examesSelecionados: previousExamesSelecionados,
                            desativaFeedbackPorMensagem: { desativaFeedbackPorMensagem: true, componenteConvenio: true }
                        }]);

                        ocrProcessed = true;

                        // Limpar estados após erro/divergência na carteirinha
                        console.log('🎯 Erro/divergência no processamento de carteirinha, limpando estados');
                        clearPollingState(false);
                        return true;
                    } else {
                        const marca = searchParams.get('marca') || 'AM';
                        const origem = searchParams.get('origem') || 'chat-web';
                        const currentClientId = newIdd !== '' ? newIdd : client_id;

                        // Criar uma cópia do insuranceSelected para evitar problemas de referência
                        const insuranceSelectedCopy = {
                            insurance: {
                                id: String(insuranceSelected.insurance.id || ''),
                                name: String(insuranceSelected.insurance.name || '')
                            },
                            company: {
                                id: String(insuranceSelected.company.id || ''),
                                name: String(insuranceSelected.company.name || '')
                            },
                            plan: {
                                id: String(insuranceSelected.plan.id || ''),
                                name: String(insuranceSelected.plan.name || '')
                            },
                            card: {
                                number: String(insuranceSelected.card.number || ''),
                                ValidThru: String(insuranceSelected.card.ValidThru || '')
                            },
                            isManual: false
                        };

                        // Remover typing antes de enviar
                        setMessages(prev => {
                            const lastIsTyping = prev.length > 0 && (prev[prev.length - 1]?.typing === true || (prev[prev.length - 1]?.origin === 'bot' && prev[prev.length - 1]?.response === 'Digitando...'));
                            return lastIsTyping ? prev.slice(0, -1) : prev;
                        });

                        sendMessage(
                            setMessages,
                            currentClientId,
                            '',
                            messages,
                            marca,
                            origem,
                            null,
                            location,
                            location.lat,
                            location.long,
                            null,
                            setTeste2,
                            requestLocation,
                            sistema,
                            versao,
                            [...messages].reverse().find(m => m?.examesSelecionados)?.examesSelecionados || null,
                            null,
                            requestImage,
                            setRequestId,
                            insuranceSelectedCopy
                        );

                        console.log('✅ sendMessage chamado com sucesso');

                        ocrProcessed = true;

                        // Limpar TODOS os estados após processar carteirinha com sucesso
                        // Não resetar contador de exames pois carteirinha é independente
                        console.log('🎯 Processamento de carteirinha concluído, limpando estados do polling');
                        clearPollingState(false);
                        return true;
                    }

                } else {
                    // Caso OCR sem exams e sem procedimentosRemoved - aguardar mais
                    console.log(`⚠️ Payload incompleto, aguardando ${ocrPollingIntervalMs / 1000} segundos para nova tentativa...`);
                    await new Promise(resolve => setTimeout(resolve, ocrPollingIntervalMs));
                    return await pollLoop();
                }

            } catch (error) {
                console.error('❌ Erro ao consultar API OCR:', error);
                // Aguardar o intervalo de polling e tentar novamente
                await new Promise(resolve => setTimeout(resolve, ocrPollingIntervalMs));
                return await pollLoop();
            }
        };

        return await pollLoop();
    };

    // Resetar contador de OCR quando mudar de requestId e o tipo de OCR for de exames
    useEffect(() => {
        // Inicializar contador no window se não existir
        if (typeof window.currentOcrExamesCount === 'undefined') {
            window.currentOcrExamesCount = 0;
        }
        // Inicializar baseline de respostas de OCR de exames
        if (typeof window.ocrExamesBaselineCount === 'undefined') {
            window.ocrExamesBaselineCount = 0;
        }
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (teste2 === false && contadorGeoLoc === true) {
                setMessages(messages => {
                    const lastIsTyping = messages.length > 0 && (messages[messages.length - 1]?.typing === true || (messages[messages.length - 1]?.origin === 'bot' && messages[messages.length - 1]?.response === 'Digitando...'));
                    return lastIsTyping ? messages.slice(0, -1) : messages;
                });
                setMessages(messages => [...messages, { origin: 'bot', response: 'Para calcular a unidade mais próxima de você, preciso do seu endereço completo ou CEP. Poderia fornecer essa informação, por favor?', request: "", desativaFeedbackPorMensagem: true }]);
            }
        }, 20000); // Convert timeout to a number or use a default value of 20000 if it is not provided.

        return () => clearTimeout(timer);
    }, [contadorGeoLoc]);


    useEffect(() => {
        if (teste2 === true) {
            setTeste2(false)
            setContadorGeoLoc(false)
            const marca = searchParams.get('marca');
            const origem = searchParams.get('origem');
            const localizacao = { latitude: location.lat, longitude: location.long }
            const context = { context: { localizacao } }
            const typing = { origin: 'bot', response: 'Digitando...', options: [], typing: true };
            setMessages(messages => [...messages, typing]);
            sendMessage(setMessages, client_id, "", messages, marca, origem, context, localizacao, location.lat, location.log, messages[messages.length - 1].response, setTeste2, requestLocation, sistema, versao, null, null, requestImage, setRequestId);
        }
    }, [teste2])

    useEffect(() => {
        if (messages.length > 0) {
            const lastMessage = messages[messages.length - 1];

            // Verificar se a última mensagem é a mensagem de aviso sobre o limite de caracteres
            if (lastMessage.isLimitWarning) {
                return;
            }

            // Verificar se deve mostrar o CSAT baseado na resposta da API
            if (lastMessage.csat) {
                startCSATTimer();
            }

            // Verificar se deve mostrar feedback do input
            if (lastMessage.inputReclamacao) {
                setShowInputFeedback(true);
                setCurrentCharLimit(FEEDBACK_CHAR_LIMIT);
            } else if (lastMessage.inputElogio) {
                setShowInputFeedback(true);
                setCurrentCharLimit(ELOGIO_CHAR_LIMIT);
            } else if (lastMessage.inputSugestao) {
                setShowInputFeedback(true);
                setCurrentCharLimit(ELOGIO_CHAR_LIMIT);
            } else if (!showInputFeedback) {
                // Só volta para o limite normal se não estiver no modo de feedback
                setCurrentCharLimit(NORMAL_CHAR_LIMIT);
            } else if (!lastMessage.inputReclamacao && !lastMessage.inputElogio && !lastMessage.inputSugestao) {
                // Se não for uma mensagem de feedback e estamos no modo de feedback, desativa o modo
                setShowInputFeedback(false);
                setCurrentCharLimit(NORMAL_CHAR_LIMIT);
            }
        }
    }, [messages]);

    // Adicione esta nova função para ajustar a altura do textarea
    const adjustTextareaHeight = (element) => {
        element.style.height = 'auto';
        element.style.height = Math.min(element.scrollHeight, 150) + 'px'; // limite máximo de 150px
    };

    const handleInputChange = (e) => {
        let newValue = e.target.value;
        if (bloqueiaInputLetras) {
            newValue = newValue.replace(/\D/g, '');
        }

        // Limita o texto ao número máximo de caracteres permitido
        if (newValue.length > currentCharLimit) {
            // Se o usuário tentar digitar mais que o limite, trunca o texto
            setInputValue(newValue.substring(0, currentCharLimit));
            setCharCount(currentCharLimit);
            adjustTextareaHeight(e.target);

            // Se ainda não mostrou a mensagem de limite, mostra agora
            if (!limitMessageShown) {
                showLimitWarningMessage();
            }

            return;
        }

        setCharCount(newValue.length);

        // Ajusta a altura do textarea
        adjustTextareaHeight(e.target);

        // Avisa quando o usuário atingir exatamente o limite de caracteres
        if (newValue.length === currentCharLimit && !limitMessageShown) {
            showLimitWarningMessage();
        } else if (newValue.length < currentCharLimit) {
            // Reseta o estado quando o usuário apaga caracteres
            setLimitMessageShown(false);
        }

        setInputValue(newValue);
    };

    // Função para mostrar a mensagem de aviso de limite
    const showLimitWarningMessage = () => {
        setLimitMessageShown(true);

        setMessages(prevMessages => {
            // Encontra a última mensagem real (não aviso)
            const lastRealMessage = [...prevMessages].reverse().find(msg => !msg.isLimitWarning);

            let warningMessage = 'Para que eu possa te ajudar melhor, por favor, escreva sua dúvida utilizando menos palavras. Assim, consigo entender e responder com mais precisão.';

            if (lastRealMessage) {
                if (lastRealMessage.inputReclamacao) {
                    warningMessage = 'O seu relato excedeu o limite de caracteres. Para continuar, descreva um resumo da sua reclamação, por favor.';
                } else if (lastRealMessage.inputElogio) {
                    warningMessage = 'O seu elogio excedeu o limite de caracteres. Para continuar, descreva um resumo do seu elogio, por favor.';
                } else if (lastRealMessage.inputSugestao) {
                    warningMessage = 'A sua sugestão excedeu o limite de caracteres. Para continuar, descreva um resumo da sua sugestão, por favor.';
                }
            }

            return [...prevMessages, {
                origin: 'bot',
                response: warningMessage,
                request: "",
                isLimitWarning: true,
                desativaFeedbackPorMensagem: true // Desativar feedback para mensagens de aviso
            }];
        });
    };

    // Garantir que o contador de caracteres seja exibido corretamente quando o limite é alterado
    useEffect(() => {
        // Se o valor atual do input for maior que o novo limite, trunca o texto
        if (inputValue.length > currentCharLimit) {
            setInputValue(inputValue.substring(0, currentCharLimit));
            setCharCount(currentCharLimit);
        }
    }, [currentCharLimit]);

    const handleSendMessage = () => {
        let client_id = searchParams.get('client_id');
        const marca = searchParams.get('marca');
        const origem = searchParams.get('origem');

        if (inputValue.trim()) {
            // Verificar se a mensagem é um comando especial
            if (inputValue.startsWith("!mudaID ")) {
                const newId = inputValue.split(" ")[1];
                setClient_id(newId);
                setNewId(newId);
                client_id = newId;
                const typing = { origin: 'bot', response: `Mudando para o ID ${newId}`, options: [] };
                setMessages(messages => [...messages, typing]);
                setInputValue('');
                setCharCount(0);
                setLimitMessageShown(false);
                if (textareaRef && textareaRef.current) {
                    textareaRef.current.style.height = 'auto';
                }
            } else if (inputValue === "!host") {
                setMessages(messages => [...messages, { origin: 'bot', response: `${window.location.href}`, request: "", desativaFeedbackPorMensagem: true }]);
                setInputValue('');
                setCharCount(0);
                setLimitMessageShown(false);
                if (textareaRef && textareaRef.current) {
                    textareaRef.current.style.height = 'auto';
                }
            } else {
                // Mensagem normal do usuário - sanitizar apenas se não for de um botão confiável
                const messageText = inputValue.trim();
                checkTimerStateOnUserMessage(messageText);
                const isTrustedMessage = trustedButtonMessages.includes(messageText);

                // Se for uma mensagem confiável, não sanitize
                const finalMessage = isTrustedMessage ? messageText : sanitizeInput(messageText);

                // Remover da lista de mensagens confiáveis após uso
                if (isTrustedMessage) {
                    setTrustedButtonMessages(prev => prev.filter(msg => msg !== messageText));
                }

                const body = { origin: 'you', response: finalMessage, options: [] };
                setMessages(messages => [...messages, body]);
                const typing = { origin: 'bot', response: 'Digitando...', options: [], typing: true, isConfirmandoAgendamento: finalMessage && typeof finalMessage === 'string' && !!finalMessage.match(/confirmar.*agendamento/i) };
                setMessages(messages => [...messages, typing]);
                setInputValue('');
                setCharCount(0);
                setLimitMessageShown(false);
                if (textareaRef && textareaRef.current) {
                    textareaRef.current.style.height = 'auto';
                }

                if (contadorGeoLoc == true) {
                    setContadorGeoLoc(false)
                    if (newIdd != '') {
                        sendMessage(setMessages, newIdd, body.response, messages, marca, origem, null, null, location.lat, location.long, body.response, setTeste2, requestLocation, sistema, versao, null, null, requestImage, setRequestId);
                    } else {
                        sendMessage(setMessages, client_id, body.response, messages, marca, origem, null, null, location.lat, location.long, body.response, setTeste2, requestLocation, sistema, versao, null, null, requestImage, setRequestId);
                    }
                } else {
                    if (newIdd != '') {
                        sendMessage(setMessages, newIdd, body.response, messages, marca, origem, null, null, location.lat, location.long, null, setTeste2, requestLocation, sistema, versao, null, null, requestImage, setRequestId);
                    } else {
                        sendMessage(setMessages, client_id, body.response, messages, marca, origem, null, null, location.lat, location.long, null, setTeste2, requestLocation, sistema, versao, null, null, requestImage, setRequestId);
                    }
                }
            }
        }
    };

    // Função para lidar com o envio de informações sobre o download de PDF
    const handleSendMessagePDF = () => {
        // Esta função será chamada quando o usuário clicar no botão de baixar PDF
        // Podemos usar para registrar analytics ou executar ações adicionais
        // Por enquanto, apenas registramos no console
        console.log("Usuário baixou um arquivo PDF");

        // Se necessário, podemos adicionar uma mensagem de confirmação
        // setMessages(messages => [...messages, { 
        //     origin: 'bot', 
        //     response: 'O download do seu documento foi iniciado.', 
        //     options: [] 
        // }]);
    };

    const requestLocation = () => {

        setContadorGeoLoc(true);

        if (window.Android) {
            // Chamada do app em adroid para compartilhar a localizção
            window.Android.chatRequestUserLocation();

        } else {
            // Envia uma mensagem para o código Swift para solicitar a localização do usuário
            window.webkit.messageHandlers.chatRequestUserLocation.postMessage(null);
        }
    }

    const requestImage = async (providedRequestId = null, ocrType = 'normal', idPessoaFisica = null, ocrProvider = 'fleury') => {

        console.log('📸 requestImage chamado:', { providedRequestId, ocrType, idPessoaFisica });

        // Resetar flags de polling/cancelamento residuais de sessões anteriores
        // (ex.: timeout de "no-image-received" que setou cancelCurrentOcrPolling = true)
        window.cancelCurrentOcrPolling = false;
        window.isPollingActive = false;
        
        // Atualizar requestId no estado e no window
        if (providedRequestId) {
            const newReqId = String(providedRequestId);
            console.log('🔑 Atualizando requestId em requestImage:', newReqId);
            setRequestId(newReqId);
            window.currentRequestId = newReqId;
        }

        // Para o fluxo de exames (ocrType === 'normal'), o número TOTAL de respostas de exames
        // esperadas para um determinado requestId deve considerar TODOS os arquivos enviados
        // nesse mesmo request. Por isso:
        // - não zeramos o contador ao processar cada resposta (clearAllOCRStates não reseta);
        // - reinicializamos o contador apenas quando o requestId de OCR muda.
        if (ocrType === 'normal' && providedRequestId) {
            const newReqId = String(providedRequestId);
            const previousReqId = window.currentOcrRequestId || null;

            if (previousReqId !== newReqId) {
                console.log('🔢 Novo requestId de OCR de exames detectado, resetando contador global:', {
                    previousReqId,
                    newReqId
                });
                window.currentOcrRequestId = newReqId;
                window.currentOcrExamesCount = 0;
                setOcrExamesCount(0);
                window.ocrExamesBaselineCount = 0;
            } else {
                // Mesmo requestId: o usuário está enviando mais um arquivo ou reenviando
                // Guardar baseline: quantidade de respostas já processadas pela API
                // O polling anterior já processou N respostas. Ao enviar mais um arquivo,
                // o novo polling deve esperar baseline + novas respostas.
                const currentBaseline = window.ocrExamesBaselineCount || 0;
                const previousCount = window.currentOcrExamesCount || 0;
                window.ocrExamesBaselineCount = currentBaseline + previousCount;
                window.currentOcrExamesCount = 0;
                setOcrExamesCount(0);
                console.log('➿ Mesmo requestId de OCR de exames, atualizando baseline para reenvio:', {
                    baseline: window.ocrExamesBaselineCount,
                    previousCount,
                    newExpectedCount: 0
                });
            }
        }

        // Armazenar o tipo de OCR e idPessoaFisica para usar quando o arquivo for enviado
        window.currentOcrType = ocrType;
        window.currentOcrProvider = ocrProvider === 'firstlayer' &&
            (ocrType === 'pedido-medico' || ocrType === 'ocr-carteirinha') ? 'firstlayer' : 'fleury';
        window.currentIdPessoaFisica = idPessoaFisica;

        // O timer de timeout de imagem foi removido completamente.
        // O envio de 'no-image-received' agora é disparado via window.closeBottomSheetByUser

        // Chama o seletor de arquivo nativo (Android/iOS) ou, em ambiente web/desktop,
        // abre um seletor de arquivo do navegador para permitir upload pelo PC.
        const isAndroidBridgeAvailable =
            typeof window !== 'undefined' &&
            window.Android &&
            typeof window.Android.openBottomSheetSelectFile === 'function';

        const isIOSBridgeAvailable =
            typeof window !== 'undefined' &&
            window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.openBottomSheetSelectFile;

        if (isAndroidBridgeAvailable) {
            // App Android nativo
            window.Android.openBottomSheetSelectFile();
        } else if (isIOSBridgeAvailable) {
            // App iOS nativo (Swift)
            window.webkit.messageHandlers.openBottomSheetSelectFile.postMessage(null);
        } else {
            // Fallback Web/Desktop: abrir seletor de arquivos do navegador
            console.log('🖥️ Ambiente web/desktop detectado, abrindo seletor de arquivo do navegador para OCR.');

            const input = document.createElement('input');
            input.type = 'file';
            // Para exames e pedido médico, permitir imagem/PDF; para carteirinha, focar em imagem
            input.accept = ocrType === 'ocr-carteirinha'
                ? 'image/*'
                : 'image/*,application/pdf';
            // Seleção múltipla apenas para OCR de exames
            input.multiple = ocrType === 'normal';
            input.style.display = 'none';

            input.addEventListener('change', (event) => {
                const files = Array.from(event.target.files || []);
                if (!files.length) {
                    console.log('Nenhum arquivo selecionado para OCR.');
                    if (typeof window.closeBottomSheetByUser === 'function') {
                        window.closeBottomSheetByUser();
                    } else {
                        console.error('❌ window.closeBottomSheetByUser não está definido.');
                    }
                    document.body.removeChild(input);
                    return;
                }

                files.forEach((file) => {
                    const reader = new FileReader();

                    reader.onload = (e) => {
                        const base64Data = e.target.result;
                        if (typeof window.chatSendFile === 'function') {
                            console.log('📄 Arquivo lido com sucesso, enviando via chatSendFile (web/desktop).', {
                                name: file.name,
                                size: file.size,
                                type: file.type,
                                ocrType
                            });
                            window.chatSendFile(base64Data);
                        } else {
                            console.error('❌ window.chatSendFile não está definido. Não foi possível enviar o arquivo para OCR.');
                        }
                    };

                    reader.onerror = (err) => {
                        console.error('❌ Erro ao ler arquivo selecionado para OCR:', err);
                    };

                    reader.readAsDataURL(file);
                });

                document.body.removeChild(input);
            });

            input.addEventListener('cancel', () => {
                console.log('Seleção de arquivo cancelada pelo usuário (cancel).');
                if (typeof window.closeBottomSheetByUser === 'function') {
                    window.closeBottomSheetByUser();
                } else {
                    console.error('❌ window.closeBottomSheetByUser não está definido.');
                }
                document.body.removeChild(input);
            });

            document.body.appendChild(input);
            input.click();
        }

        if (ocrType === 'pedido-medico') {
            setMessages(messages => {
                const lastIsTyping = messages.length > 0 && (messages[messages.length - 1]?.typing === true || (messages[messages.length - 1]?.origin === 'bot' && messages[messages.length - 1]?.response === 'Digitando...'));
                return lastIsTyping ? messages.slice(0, -1) : messages;
            });
        }
    }

    window.chatSendFile = async (fileBase64) => {

        console.log('📁 ========== chatSendFile INICIADO ==========');

        // Resetar qualquer cancelamento anterior ao iniciar o envio do arquivo
        window.cancelCurrentOcrPolling = false;
        console.log('   requestId local:', requestId);
        console.log('   window.currentRequestId:', window.currentRequestId);
        console.log('   window.currentOcrType:', window.currentOcrType);
        console.log('   window.currentOcrExamesCount:', window.currentOcrExamesCount);
        console.log('============================================');

        // O timer foi removido, então não há necessidade de cancelar o timeout da imagem.

        // Resetar flags de cancelamento/polling residuais para que o novo polling funcione
        window.cancelCurrentOcrPolling = false;
        window.isPollingActive = false;

        // Recuperar o tipo de OCR e idPessoaFisica armazenados
        const ocrType = window.currentOcrType || 'normal';
        const ocrProvider = window.currentOcrProvider || 'fleury';
        const idPessoaFisica = window.currentIdPessoaFisica || null;
        const reqIdToSend = window.currentRequestId || requestId;

        // Obter a contagem inicial real de exames processados no backend antes de enviar o novo
        if (ocrType === 'normal' && reqIdToSend) {
            try {
                let extraQueryParams = '&brandInitials=AM&regional=SP';
                if (typeof window !== 'undefined' && typeof window.currentClienteSexo === 'string') {
                    const sexo = window.currentClienteSexo.trim().toUpperCase();
                    if (sexo === 'M' || sexo === 'F') {
                        extraQueryParams += `&sexo=${encodeURIComponent(sexo)}`;
                    }
                }
                console.log(`📡 Buscando contagem inicial de exames OCR no backend antes do envio...`);
                const response = await fetch(`${apiBaseUrl}/get-ocr-payload?requestId=${reqIdToSend}${extraQueryParams}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                if (response.ok) {
                    const apiResponse = await response.json();
                    if (apiResponse && apiResponse.data && Array.isArray(apiResponse.data)) {
                        const corpo = apiResponse.data.find(item => item.type === 'ocr');
                        if (corpo) {
                            const backendCount = corpo.quantidadeRespostasExames || 0;
                            const prevBaseline = window.ocrExamesBaselineCount || 0;
                            window.ocrExamesBaselineCount = Math.max(prevBaseline, backendCount);
                            console.log('📊 Contagem de exames OCR sincronizada com o backend:', {
                                backendCount,
                                prevBaseline,
                                finalBaseline: window.ocrExamesBaselineCount
                            });
                        }
                    }
                }
            } catch (e) {
                console.error('⚠️ Erro ao obter contagem inicial de exames do OCR no backend:', e);
            }
        }

        console.log('🖼️ chatSendFile configurado:', {
            ocrType,
            idPessoaFisica,
            requestIdUsado: reqIdToSend
        });

        const marca = searchParams.get('marca') || 'fleury';
        const origem = searchParams.get('origem') || 'app';
        const operational_system = searchParams.get('operational_system') || 'web';
        const version_app = searchParams.get('version_app') || '1.0';

        // Para OCR de exames (ocrType === 'normal'), cada arquivo enviado incrementa o contador
        // esperado de respostas do OCR. Isso garante que o polling só finalize quando todas
        // as respostas de exames tiverem sido processadas pelo backend.
        if (ocrType === 'normal') {
            setOcrExamesCount(prev => {
                const newCount = prev + 1;
                console.log('📈 Incrementando contador de OCR de exames (por arquivo enviado):', {
                    anterior: prev,
                    novo: newCount,
                    requestIdUsado: reqIdToSend
                });
                window.currentOcrExamesCount = newCount; // Guardar também no window para acesso global
                return newCount;
            });
        }

        // Remover typing anterior e adicionar novo (garante que sempre há typing durante processamento)
        setMessages(messages => {
            const lastIsTyping = messages.length > 0 && (messages[messages.length - 1]?.typing === true || (messages[messages.length - 1]?.origin === 'bot' && messages[messages.length - 1]?.response === 'Digitando...'));
            return lastIsTyping ? messages.slice(0, -1) : messages;
        });

        if (ocrType === 'normal' || ocrType === 'pedido-medico') {
            const typing = { origin: 'bot', response: 'Digitando...', options: [], typing: true, bloqueiaInput: true, isBuscaExamesOcrLoading: true };
            setMessages(messages => [...messages, typing]);
        } else if (ocrType === 'ocr-carteirinha') {
            const typing = { origin: 'bot', response: 'Digitando...', options: [], typing: true, bloqueiaInput: true, isOcrCarteirinhaLoading: true };
            setMessages(messages => [...messages, typing]);
        } else {
            const mensagemEspera = { origin: 'bot', response: 'Estamos realizando a leitura do documento. Isso pode levar alguns segundos.', options: [], typing: false, bloqueiaInput: true, desativaFeedbackPorMensagem: true };
            setMessages(messages => [...messages, mensagemEspera]);
            
            const typing = { origin: 'bot', response: 'Digitando...', options: [], typing: true, bloqueiaInput: true };
            setMessages(messages => [...messages, typing]);
        }

        console.log('📤 Enviando arquivo para processamento:', {
            requestId: reqIdToSend,
            ocrType,
            idPessoaFisica
        });

        await sendFile(
            fileBase64,
            client_id,
            reqIdToSend, // Usar o requestId atualizado
            setMessages,
            messages,
            ocrType,
            idPessoaFisica,
            marca,
            origem,
            sendMessage, // callback para sendMessage
            requestLocation, // getLocation
            operational_system,
            version_app,
            setRequestId,
            ocrProvider
        );

        // Após enviar o arquivo, aguardar um pouco e começar a consultar a API
        // ATENÇÃO: para ocrType === 'pedido-medico' (ocrApenasPedidoMedico), NÃO iniciamos polling.
        // Nesse fluxo, o backend apenas recebe o arquivo e o fluxo continua via sendMessageCallback.
        if (ocrProvider !== 'firstlayer' && (ocrType === 'normal' || ocrType === 'ocr-carteirinha')) {
            setTimeout(() => {
                // Usar o requestId mais atualizado (window.currentRequestId ou requestId local)
                const reqIdToUse = window.currentRequestId || requestId;
                console.log('🔑 RequestId para polling:', {
                    windowRequestId: window.currentRequestId,
                    localRequestId: requestId,
                    usingRequestId: reqIdToUse
                });

                if (ocrType === 'ocr-carteirinha') {
                    console.log('⏳ Iniciando polling API para OCR Carteirinha');
                    pollAPIForOCRPayload(reqIdToUse, ocrType, 1); // Carteirinha sempre espera 1 resposta
                } else if (ocrType === 'normal') {
                    const expectedCount = window.currentOcrExamesCount || 1;
                    console.log('⏳ Iniciando polling API para OCR de Exames', { expectedCount, requestId: reqIdToUse });
                    pollAPIForOCRPayload(reqIdToUse, ocrType, expectedCount);
                }
            }, 2000); // Aguardar 2 segundos para o processamento no backend
        }

        // Limpar os dados após o uso
        window.currentOcrType = null;
        window.currentOcrProvider = null;
        window.currentIdPessoaFisica = null;
    }

    window.closeBottomSheetByUser = () => {
        console.log('Fechamento do bottom sheet pelo usuário (closeBottomSheetByUser), enviando no-image-received');

        const client_id_param = searchParams.get('client_id');
        const marca = searchParams.get('marca');
        const origem = searchParams.get('origem');

        const currentClientId = newIdd !== '' ? newIdd : client_id_param;

        // Marcar que o polling atual deve ser cancelado
        window.cancelCurrentOcrPolling = true;
        setOcrExamesCount(prev => {
            const newCount = prev - 1;
            console.log(' 📉 Decrementando contador de OCR de exames (por fechamento do componente pelo usuário):', {
                anterior: prev,
                novo: newCount
            });
            window.currentOcrExamesCount = newCount; // Guardar também no window para acesso global
            return newCount;
        });
        console.log('🛑 Marcando cancelamento de polling após fechamento do componente pelo usuário.');

        sendMessage(
            setMessages,
            currentClientId,
            'no-image-received',
            messages,
            marca,
            origem,
            null,
            null,
            location.lat,
            location.long,
            null,
            setTeste2,
            requestLocation,
            sistema,
            versao,
            null,
            null,
            requestImage,
            setRequestId
        );
    }

    window.chatSendUserLocation = (lat, long) => {
        // Recebe a localização do código Swift e a exibe
        setLocation({ lat, long });
        setTeste2(true)
    }

    window.chatCancelUserLocation = () => {
        setContadorGeoLoc(false)
        setMessages(messages => [...messages, { origin: 'bot', response: 'Para calcular a unidade mais próxima de você, preciso do seu endereço completo ou CEP. Poderia fornecer essa informação, por favor?', request: "", desativaFeedbackPorMensagem: true }]);
    }

    const handleRestartToInitialMenu = () => {
        console.log('🔄 Reiniciando atendimento para o Menu Inicial...');

        // 1. Limpar flags de sessionStorage e desativar histórico
        try {
            if (typeof sessionStorage !== 'undefined') {
                sessionStorage.setItem('restart_chat_initial_menu', 'true');
            }
        } catch (e) {
            console.error('Erro ao acessar sessionStorage:', e);
        }

        // 2. Limpar variáveis globais de sessão e flags de histórico
        if (typeof window !== 'undefined') {
            window.disable_history = true;
            window.disableHistory = true;
            if (window.fleuryChatConfig) {
                window.fleuryChatConfig.disable_history = true;
                window.fleuryChatConfig.disableHistory = true;
            }
            window.cancelCurrentOcrPolling = true;
            window.currentConversationId = null;
            window.currentSessionId = null;
            window.currentRequestId = null;
            window.currentIdFluxoAgendamento = null;
            window.currentInsuranceSelected = null;
            window.currentCarterinhaManual = null;
            window.currentPerson = null;
            window.currentCustomer = null;
            window.currentClienteSexo = null;
            window.currentUnidadeSelecionada = null;
        }

        // 3. Resetar estados locais do chat e forçar remontagem limpa de componentes
        setChatResetKey(prev => prev + 1);
        setTrustedButtonMessages([]);
        setNewId('');
        setUuid(uuidv4());
        setTimerActive(false);
        setTimerSeconds(null);
        setShowWarningModal(false);
        setShowExpiredModal(false);
        setIsBookingTimeExpired(false);
        setShowCSAT(false);
        setIsInputDisabled(false);
        setOcrExamesCount(0);
        setRequestId('');
        setShowInputFeedback(false);
        setLimitMessageShown(false);
        setInputValue('');
        setCharCount(0);
        if (csatTimeoutRef.current) clearTimeout(csatTimeoutRef.current);
        csatPendingAfterPaymentRef.current = false;
        warningFiredRef.current = false;
        timerEndTimeRef.current = null;

        // 4. Notificar parent via postMessage caso esteja em iframe/webview
        try {
            if (typeof window !== 'undefined' && window.parent && window.parent !== window) {
                window.parent.postMessage({ __chat_event: true, type: 'restart' }, '*');
                window.parent.postMessage({ __chat_event: true, type: 'reset' }, '*');
            }
        } catch (e) { }

        // 5. Iniciar novo atendimento
        const client_id_param = searchParams.get('client_id');
        const marca_param = searchParams.get('marca');
        const origem_param = searchParams.get('origem');
        const operational_system = searchParams.get('operational_system');
        const version_app = searchParams.get('version_app');

        const cid = client_id_param || client_id || 'web-default';
        const marc = marca_param || 'fleury';
        const orig = origem_param || 'web';

        setMessages([{ origin: 'bot', response: 'Digitando...', options: [], typing: true }]);
        const newConversationId = uuidv4();
        try { window.currentConversationId = newConversationId; } catch (e) { }

        startChat(
            [],
            setMessages,
            cid,
            marc,
            orig,
            operational_system || sistema || 'web',
            version_app || versao || '1.0',
            location,
            location?.lat || '',
            location?.long || '',
            requestLocation,
            requestImage,
            setRequestId,
            newConversationId
        );
    };

    window.chatRestartToInitialMenu = handleRestartToInitialMenu;

    useEffect(() => {
        window.chatRestartToInitialMenu = handleRestartToInitialMenu;
        return () => {
            if (window.chatRestartToInitialMenu === handleRestartToInitialMenu) {
                delete window.chatRestartToInitialMenu;
            }
        };
    });

    const handleButtonSetMessage = async (message) => {
        // Verificar se a mensagem contém PDF em base64, se sim, ignorar o processamento normal
        if (message && message.includes('data:application/pdf;base64,')) {
            // Não fazer nada aqui, pois o download será tratado no componente da mensagem
            return;
        }

        checkTimerStateOnUserMessage(message);

        const buttonContext = buttonRequestContext(searchParams);

        // ==== INTERCEPTAÇÃO PARA REINICIAR CONVERSA ====
        if (message === 'Reiniciar Atendimento') {
            handleRestartToInitialMenu();
            return;
        }

        // Adicionar a mensagem à lista de mensagens confiáveis
        setTrustedButtonMessages(prev => [...prev, message]);

        setIsInputDisabled(false);
        const body = { origin: 'you', response: message, options: [] };
        setMessages(messages => [...messages, body]);
        const typing = { origin: 'bot', response: 'Digitando...', options: [], typing: true, bloqueiaInput: true, isConfirmandoAgendamento: message && typeof message === 'string' && !!message.match(/confirmar.*agendamento/i) };
        setMessages(messages => [...messages, typing]);

        // Resetar o input e o contador
        setInputValue('');
        setCharCount(0);
        setLimitMessageShown(false);
        if (textareaRef && textareaRef.current) {
            textareaRef.current.style.height = 'auto';
        }

        if (newIdd != '') {
            sendMessage(setMessages, newIdd, body.response, messages, buttonContext.brand, buttonContext.origin, null, null, location.lat, location.long, null, setTeste2, requestLocation, sistema, versao, null, { isButton: true, button: body.response }, requestImage, setRequestId);
        } else {
            sendMessage(setMessages, buttonContext.clientId, body.response, messages, buttonContext.brand, buttonContext.origin, null, null, location.lat, location.long, null, setTeste2, requestLocation, sistema, versao, null, { isButton: true, button: body.response }, requestImage, setRequestId);
        }
    };

    const handleInputFocus = () => {
        if (window.self !== window.top) {
            try {
                window.parent.postMessage({
                    __chat_event: true,
                    type: 'input_focus'
                }, '*');
            } catch (e) { }
        }

        window.scrollTo(0, 0);

        setTimeout(() => {
            window.scrollTo(0, 0);
            if (messagesEndRef.current) {
                messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
            }
        }, 300);
    };

    const handleInputBlur = () => {
        if (window.self !== window.top) {
            try {
                window.parent.postMessage({
                    __chat_event: true,
                    type: 'input_blur'
                }, '*');
            } catch (e) { }
        }
        window.scrollTo(0, 0);
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);
    };

    return (
        <div className={`chat-container ${chatActive ? 'active' : ''} ${!chatHeader ? 'no-header' : ''} ${isAreaLogada ? 'area-logada' : ''}`} id="chat-container">
            {chatHeader && (<div className="chat-header">
                <span>{searchParams.get('origem') === 'area_logada' ? 'Chat' : 'A+ SP'}</span>
                <button 
                    className="close-button" 
                    id="close-button" 
                    aria-label="Fechar chat"
                    onClick={(e) => {
                        e.stopPropagation();
                        try {
                            if (isSdk) {
                                setMessages([]);
                                if (typeof window !== 'undefined') {
                                    window.currentConversationId = null;
                                    window.currentSessionId = null;
                                    window.currentRequestId = null;
                                    window.currentIdFluxoAgendamento = null;
                                    window.currentInsuranceSelected = null;
                                    window.currentCarterinhaManual = null;
                                    window.currentPerson = null;
                                    window.currentCustomer = null;
                                    window.currentClienteSexo = null;
                                    window.currentUnidadeSelecionada = null;
                                                }
                            }
                        } catch (err) {
                            console.error('Erro ao resetar sessão:', err);
                        }
                        setChatActive(false);
                    }}
                >
                    <IoClose />
                </button>
            </div>)}
            <div className={`chat-messages`}>
                {messages.map((message, index) => (
                    <ChatMessage
                        key={`${chatResetKey}_${message.uuid || message.id || index}`}
                        message={message}
                        handleButtonSetMessage={handleButtonSetMessage}
                        uuid={uuid}
                        arrayMessage={messages}
                        indexMessage={index}
                        client_id={newIdd !== '' ? newIdd : client_id}
                        setMessage={setMessages}
                        sendMessagePDF={handleSendMessagePDF}
                        messages={messages}
                        marca={searchParams.get('marca') || 'AM'}
                        origem={searchParams.get('origem') || 'chat-web'}
                        localizacao={location}
                        operational_system={sistema}
                        version_app={versao}
                        setRequestId={setRequestId}
                        requestImage={requestImage}
                        requestId={requestId}
                        isBookingTimeExpired={isBookingTimeExpired}
                    />
                ))}
                <div ref={messagesEndRef} />
            </div>
            {timerActive && timerSeconds !== null && timerSeconds > 0 && (
                <div className={`timer-expiration-bar ${timerSeconds <= 120 ? 'warning-pulse' : ''}`}>
                    <span>Tempo restante: <strong>{formatTime(timerSeconds)}</strong></span>
                </div>
            )}
            {inputOpen !== 'false' && (
                <div className="chat-input">
                    <div className="input-container">
                        <textarea
                            rows="1"
                            id="chat-input"
                            placeholder={isInputDisabled ? "Escolha uma das opções acima" : (searchParams.get('origem') === 'area_logada' ? "O que você precisa hoje?" : "Digite sua mensagem...")}
                            value={inputValue}
                            onChange={handleInputChange}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter' && !e.shiftKey) {
                                    e.preventDefault();
                                    handleSendMessage();
                                }
                            }}
                            maxLength={currentCharLimit}
                            disabled={isInputDisabled}
                            className={showInputFeedback ? "input-feedback" : ""}
                            ref={textareaRef}
                            inputMode={bloqueiaInputLetras ? "numeric" : undefined}
                            pattern={bloqueiaInputLetras ? "[0-9]*" : undefined}
                            onFocus={handleInputFocus}
                            onBlur={handleInputBlur}
                        />
                        <div className="char-counter">
                            <span className={charCount > currentCharLimit * 0.8 ? "char-count-warning" : ""}>
                                {charCount}/{currentCharLimit}
                            </span>
                        </div>
                    </div>
                    {!isInputDisabled && inputValue.trim().length > 0 && (
                        <button id="send-button" className="send-button" onClick={handleSendMessage} aria-label="Enviar">
                            <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
                                <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"></path>
                            </svg>
                        </button>
                    )}
                </div>
            )}

            {/* Componente CSAT (não mostrar por cima do pagamento) */}
            {showCSAT && !(typeof window !== 'undefined' && window.isPaymentModalOpen === true) && (
                <CSATComponent onClose={handleCSATClose} />
            )}

            {/* Modal de Alerta: prestes a expirar */}
            {showWarningModal && (
                <div className="timer-modal-overlay">
                    <div className="timer-modal">
                        <div className="timer-modal-header">
                            <h4>Atenção</h4>
                        </div>
                        <div className="timer-modal-body">
                            <p>Seu horário reservado está prestes a expirar. Finalize o agendamento para garantir sua vaga!</p>
                        </div>
                        <div className="timer-modal-footer">
                            <button className="timer-modal-btn" onClick={handleCloseWarningModal}>
                                Entendi
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Alerta: expirado */}
            {showExpiredModal && (
                <div className="timer-modal-overlay">
                    <div className="timer-modal">
                        <div className="timer-modal-header">
                            <h4>Não foi possível confirmar o horário</h4>
                        </div>
                        <div className="timer-modal-body">
                            <p>O horário selecionado pode não estar mais disponível. Escolha outro horário para continuar.</p>
                        </div>
                        <div className="timer-modal-footer">
                            <button className="timer-modal-btn confirm" onClick={handleCloseExpiredModal}>
                                Escolher outro horário
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
